import { Card, CardBody, StackLayout } from '@progress/kendo-react-layout'
import Env from '../../Env'
import { GoBackButton, RedirectHomeButton } from '../elements'

import './ErrorContent.css'

export interface ErrorContentProps {
  title: string
  subtitle: string
  message?: string
  returnToBefore?: boolean
  returnToHome?: boolean
}

export function ErrorContent(props: ErrorContentProps) {
  return (
    <div className="pcy-error-container">
      <h1 className="pcy-error-title">{props.title}</h1>
      <h4 className="pcy-error-subtitle">{props.subtitle}</h4>
      <hr className="pcy-error-horizon" />
      <p className="pcy-error-message">{props.message}</p>
      <Card style={{ width: '400px', margin: 'auto' }}>
        <CardBody>
          <div><strong>エラー発生時のお問い合わせはこちらから</strong></div>
          <div><span className='k-icon k-i-email' /><a href={'mailto:' + Env.ADMIN_EMAIL}>{Env.ADMIN_EMAIL}</a></div>
          <div><span className='pcy-i-phone' /><span>{Env.ADMIN_TEL}</span></div>
        </CardBody>
      </Card>
      <p />
      <StackLayout orientation="horizontal" gap={5} align={{ horizontal: 'center' }}>
        {(props.returnToBefore ?? false) && <GoBackButton className="pcy-button-long" themeColor="primary">戻る</GoBackButton>}
        {(props.returnToHome ?? false) && <RedirectHomeButton className="pcy-button-long" themeColor="primary">ホームに戻る</RedirectHomeButton>}
      </StackLayout>
    </div>
  )
}
